import React from "react";
import not from "ramda/src/not";
import { createContext } from "../../helpers/createContext";
import { usePlacementWorksheetTableContext } from "./PlacementWorksheetTableProvider";

interface IPlacementWorksheetTableRowContext {
  isExpanded: boolean;
  isLocked: boolean;
  isFinished: boolean;
  toggleLock: VoidFunction;
  toggleExpand: VoidFunction;
  setIsFinished: React.Dispatch<React.SetStateAction<boolean>>;
}

const [
  PlacementWorksheetTableRowContext,
  usePlacementWorksheetTableRowContext,
] = createContext<IPlacementWorksheetTableRowContext>();

export const PlacementWorksheetTableRowProvider: React.FC = (props) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [isLocked, setIsLocked] = React.useState(false);
  const [isFinished, setIsFinished] = React.useState(false);
  const { isShowAll } = usePlacementWorksheetTableContext();

  const toggleExpand = () => setIsExpanded(not);
  const toggleLock = () => setIsLocked(not);

  React.useEffect(() => {
    if (isFinished) {
      setTimeout(() => {
        setIsFinished(false);
      }, 700);
    }
  }, [isFinished]);

  const contextValue = React.useMemo(
    () => ({
      isLocked,
      isExpanded,
      toggleExpand,
      toggleLock,
      isFinished,
      setIsFinished,
    }),
    [isExpanded, isLocked, isFinished]
  );

  React.useEffect(() => {
    setIsExpanded(isShowAll);
  }, [isShowAll]);

  return <PlacementWorksheetTableRowContext.Provider {...props} value={contextValue} />;
};

export { usePlacementWorksheetTableRowContext };
